/**
 * Schémas de « Mon centre » — le chef de centre gère les comptes de son site
 * (décision 449, PR 3). Aucun ne porte `siteId` : le serveur impose le centre.
 */
import { z } from 'zod';
import { ROLES } from '../constants/roles.js';
import { schemaCreationUtilisateur, schemaFiltresUtilisateurs, schemaPage, schemaUtilisateurAdministre, } from './administration.js';
/** Le centre dont l'appelant est le chef, et les spécialités de sa dotation (D4). */
export const schemaCentreDuChef = z.object({
    id: z.uuid(),
    nom: z.string(),
    specialites: z.array(z.string()),
});
/** Un rôle que le chef peut attribuer (D3). */
export const schemaRoleCreable = z.object({
    code: z.string(),
    libelle: z.string(),
    base: z.enum(ROLES),
});
/** Un compte du centre ; `gerable` dit si le chef peut agir dessus (D10). */
export const schemaCompteDuCentre = schemaUtilisateurAdministre.extend({ gerable: z.boolean() });
export const schemaPageComptesDuCentre = schemaPage(schemaCompteDuCentre);
export const schemaFiltresComptesDuCentre = schemaFiltresUtilisateurs.omit({ siteId: true });
/** Strict : un champ de plus est refusé, `siteId` le premier (422 avant le schéma). */
export const schemaCreationCompteDuCentre = schemaCreationUtilisateur
    .omit({ siteId: true })
    .strict();
/**
 * D5 : nom, prénom, rôle de la liste, spécialités, désactiver. Jamais le site,
 * ni la réactivation : elle reste à la Direction (complément 449, S1125).
 */
export const schemaModificationCompteDuCentre = z
    .object({
    nom: z.string().trim().min(1).max(120),
    prenom: z.string().trim().min(1).max(120),
    roleCode: z.string().trim().min(1).max(60),
    specialites: schemaCreationUtilisateur.shape.specialites.unwrap(),
    actif: z.literal(false),
})
    .partial()
    .strict()
    .refine((valeur) => Object.keys(valeur).length > 0, {
    message: 'Aucune modification demandée.',
});
//# sourceMappingURL=centre.js.map